import { ContentEntity, ServiceEvidenceBlock } from "@/lib/types";

// Left column is the decision, right column is what it produced. Deliberately
// no overlap with servicePrinciples — this section is evidence, not values.
export const serviceEvidenceLeft: ServiceEvidenceBlock[] = [
  {
    label: "The decision",
    title: "State the problem before the pitch",
    copy: "Chic & Charming had a strong market reputation and a weak journey — friction in product discovery, inconsistent messaging and limited mobile optimisation. We wrote that down before anyone opened a canvas.",
    tone: "plain",
  },
  {
    label: "The research",
    stat: "70%",
    copy: "of fashion shoppers prefer a minimal interface with product imagery in front. That finding set the visual hierarchy and cut the click-depth — not a stakeholder's taste.",
    tone: "lime",
  },
  {
    label: "The decision",
    title: "Architecture is a design choice",
    copy: "A Next.js build with optimised image delivery gave near-instant loads across regions. The shortest route to a better conversion number turned out to be a technical one.",
    tone: "plain",
  },
  {
    label: "The result",
    stat: "−25%",
    copy: "Bounce rate on the same marketplace inside the first month after launch.",
    tone: "dark",
  },
];

export const serviceEvidenceRight: ServiceEvidenceBlock[] = [
  {
    label: "The result",
    stat: "+40%",
    copy: "Conversion rate on the Chic & Charming marketplace, first month post-launch, from the same rebuild.",
    tone: "dark",
  },
  {
    label: "The decision",
    title: "In luxury, trust is the product",
    copy: "Elorva sells authentic fragrance in a market full of counterfeits, so provenance, packaging detail and checkout confidence carried more weight than any discount mechanic.",
    tone: "plain",
  },
  {
    label: "The result",
    stat: "BDT 3M+",
    copy: "Revenue scaled through the Elorva storefront in the authentic fragrance category.",
    tone: "lime",
  },
  {
    label: "The decision",
    title: "One page can carry a funnel",
    copy: "Moson Media needed positioning, proof and speed on a single landing page rather than a site. It has since powered growth for 45+ startups, and Artevic's studio site now fronts a roster including Daymond John and Biohack Yourself.",
    tone: "plain",
  },
];

export const serviceFaqs: ContentEntity[] = [
  {
    title: "Can we start with one service?",
    description:
      "Yes. Most engagements start with one and grow. The five stages run the same whether the scope is a logo or a platform.",
  },
  {
    title: "How fast can you start?",
    description:
      "Discovery usually begins within two weeks of a signed scope. Video work can start sooner, because the footage already exists.",
  },
  {
    title: "Who owns the work?",
    description:
      "You do — source files, repositories and design systems transfer on final payment. No licence, no lock-in.",
  },
  {
    title: "Do you work internationally?",
    description:
      "Most of our roster is. Delivery is remote-first, with overlap hours agreed before the project starts.",
  },
];
